import { Model } from "survey-core";
import { Survey } from "survey-react-ui";
import "survey-core/defaultV2.min.css";
import { renderJson, themeJson } from "./assessmentSurvey";
import { darkTheme } from "./assessmentSurvey";
import { useLazyAddAssessmentSurveyResultQuery } from "@lxp-app/components/molecules/surveyjs/survey-slice/surveySlice";
import { memo, useCallback, useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import { RootState } from "@lxp-app/store/store";
import orgBasedFeatureNameMapping from "@assessment/utils/orgBasedFeatureName";
import { useTranslation } from "react-i18next";

const SurveyComponent = ({
  surveyParentId,
  surveyId,
  setSubmitLoading,
  setRes,
  ongoingId
}: {
  surveyParentId: string | null;
  surveyId: string | null;
  setSubmitLoading: any;
  setRes: any;
  ongoingId: string | null;
}) => {
  const { t } = useTranslation();
  const theme = themeJson as any;
  const { isDarkMode } = useSelector((state: any) => state.DarkmodeSlice);
  const isHitachiOrg = useSelector(
    (state: RootState) => state.UserInfoSlice.profile.isHitachiOrg
  );
  const user = useSelector((state: any) => state.UserInfoSlice.profile);
  const orgBasedFeatureName =
    orgBasedFeatureNameMapping[user?.org || "default"] ||
    orgBasedFeatureNameMapping["default"];

  const json = useMemo(
    () => renderJson(orgBasedFeatureName, t) as any,
    [orgBasedFeatureName, t]
  );
  const [addAssessmentSurveyResult, { isLoading }] =
    useLazyAddAssessmentSurveyResultQuery();

  const sendSurveyResult = useCallback(
    async (data: any) => {
      try {
        const res = await addAssessmentSurveyResult({
          surveyId,
          parentId: surveyParentId,
          survey: data,
          ongoingId
        });
        if (res?.data?.error.length === 0) {
          localStorage.setItem("feedbackSubmitted", "true");
        }
        setRes(res?.data?.error);
        return true;
      } catch (error) {
        console.error("API Error:", error);
        return false;
      }
    },
    [addAssessmentSurveyResult, ongoingId, setRes, surveyId, surveyParentId]
  );

  useEffect(() => {
    setSubmitLoading(isLoading);
  }, [isLoading, setSubmitLoading]);

  const survey = useMemo(() => {
    const s = new Model(json);
    s.applyTheme(isDarkMode ? (darkTheme as any) : (theme as any));

    s.showCompletedPage = false;

    s.onComplete.add(async (sender) => {
      const success = await sendSurveyResult(sender.data);
      if (success) {
        sender.completeLastPage();
      }
    });

    return s;
  }, [json, sendSurveyResult, isDarkMode]);

  useEffect(() => {
    theme.cssVariables["--sjs-primary-backcolor"] = isHitachiOrg
      ? "#d40000"
      : "#00875c";
    theme.cssVariables["--sjs-primary-backcolor-dark"] = isHitachiOrg
      ? "rgb(181, 2, 2)"
      : "rgba(0, 120, 82, 1)";
    darkTheme.cssVariables["--sjs-primary-backcolor"] = isHitachiOrg
      ? "rgb(181, 2, 2)"
      : "rgba(0, 135, 93, 1)";
    darkTheme.cssVariables["--sjs-primary-backcolor-dark"] = isHitachiOrg
      ? "rgb(181, 2, 2)"
      : "rgb(207,2,2)";
  }, []);

  return (
    <div className="rounded-3xl overflow-hidden">
      <Survey model={survey} />
    </div>
  );
};

export default memo(SurveyComponent);
